import {
  ChangeActiveChutePayload,
  ensureStarted,
  getSortingCenterHub,
} from '@shared/config/signalR/SortingSettingsHub';
import { useEffect } from 'react';
import { useChuteSettingsStore } from './useChuteSettingsStore';

export default function useSignalRConnection() {
  const { setChuteStatus } = useChuteSettingsStore();
  useEffect(() => {
    const conn = getSortingCenterHub();

    const onChuteOpened = (data: ChangeActiveChutePayload) => {
      setChuteStatus(data.chuteNumber, data.status);
    };
    const onChuteClosed = (data: ChangeActiveChutePayload) => {
      setChuteStatus(data.chuteNumber, data.status);
    };

    conn.on('ChuteOpened', onChuteOpened);
    conn.on('ChuteClosed', onChuteClosed);

    conn.onreconnecting((err) => console.warn('SignalR reconnecting…', err?.message));
    conn.onreconnected((newId) => console.info('SignalR reconnected', newId));
    conn.onclose((err) => console.error('SignalR closed', err?.message));

    (async () => {
      await ensureStarted(conn);
      console.info('SignalR connected', conn.connectionId);
    })();

    return () => {
      conn.off('ChuteOpened', onChuteOpened);
      conn.off('ChuteClosed', onChuteClosed);
    };
  }, []);
}
